import React from 'react';
import { ReviewTemplateProps } from './types';
import ShareReviewTemplate1 from './templates/ShareReviewTemplate1';
import ShareReviewTemplate2 from './templates/ShareReviewTemplate2';
import ShareReviewTemplate3 from './templates/ShareReviewTemplate3';
import ShareReviewTemplate4 from './templates/ShareReviewTemplate4';
import ShareReviewTemplate5 from './templates/ShareReviewTemplate5';

export interface TemplateConfig {
    id: string;
    name: string;
    component: React.FC<ReviewTemplateProps>;
}

export const TEMPLATE_REGISTRY: TemplateConfig[] = [
    {
        id: 'template1',
        name: 'Template 1',
        component: ShareReviewTemplate1,
    },
    {
        id: 'template2',
        name: 'Template 2',
        component: ShareReviewTemplate2,
    },
    {
        id: 'template3',
        name: 'Template 3',
        component: ShareReviewTemplate3,
    },
    {
        id: 'template4',
        name: 'Template 4',
        component: ShareReviewTemplate4,
    },
    {
        id: 'template5',
        name: 'Template 5',
        component: ShareReviewTemplate5,
    },
];

export const getTemplateById = (templateId: string): TemplateConfig | undefined => {
    return TEMPLATE_REGISTRY.find(t => t.id === templateId);
};

export const getTemplateComponent = (
    templateId: string,
): React.FC<ReviewTemplateProps> | undefined => {
    return getTemplateById(templateId)?.component;
};

export type TemplateId = (typeof TEMPLATE_REGISTRY)[number]['id'];
